const route = {
    path: '/library',
    meta: { authClass: 'protected' },
    children: [
        {
            path: '',
            components: {
                default:
                    () => import(/* webpackChunkName: "library" */ '../../components/views/library/library.vue'),
            }
        },
        {
            path: 'upload',
            components: {
                default:
                    () => import(/* webpackChunkName: "library" */ '../../components/views/library/upload.vue'),
            }
        },
        {
            path: ':id',
            components: {
                default:
                    () => import(/* webpackChunkName: "library" */ '../../components/views/library/view.vue'),
            }
        },
    ],
}

module.exports = route;